(function () {
  const el = document.getElementById('jp-estimated-delivery');
  if (!el) return;

  const offsetDays = parseInt(el.dataset.offsetDays, 10);
  if (isNaN(offsetDays)) return; // show nothing if delivery_days not set

  const cutoffHour = parseInt(el.dataset.cutoffHour || '0', 10);
  const now = new Date();
  const base = new Date(now);
  if (now.getHours() >= cutoffHour) base.setDate(base.getDate() + 1);

  const target = new Date(base);
  target.setDate(target.getDate() + offsetDays);

  const month = target.getMonth() + 1;
  const day = target.getDate();

  // EXACT phrasing
  el.textContent = `今ご注文で${month}月${day}日までにお届け`;
})();

